import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axiosInstance from "../../services/axiosComman";
import NuDateFormat from "../../utils/NuDate";

function DashboardTableView({
  url = "",
  title = "",
  link=""
}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  async function getFunction() {
    setLoading(true);
    await axiosInstance.get(`${url}`).then((res) => {
      setLoading(false);
      setData(res?.data?.data);
    }).catch(err=>{
      setLoading(false);
      console.error(err);
    });
  }

  useEffect(() => {
    getFunction();
  }, [url]);

  return (
    <div className=" w-full h-full p-4 bg-white shadow-main rounded-md overflow-hidden">
      <Link to={link}>
        <p className="text-xs 2xl:text-sm text-[#6E6985] pb-1">{title}</p>
      </Link>
      <div className=" w-full relative  h-full ">
        <div className=" w-full grid grid-cols-2 gap-x-4 sticky top-0">
          <div className="w-full h-8 bg-[#F2E9FF] rounded-md p-1.5">
            <p className="text-xs 2xl:text-sm text-[#7030A0] pl-2 pb-5">Previous Date</p>
          </div>

          <div className="w-full h-8 bg-[#F2E9FF] rounded-md p-1.5">
            <p className="text-xs 2xl:text-sm text-[#7030A0] pl-2 pb-5">Upcoming Date</p>
          </div>
        </div>
        <div className=" w-full grid grid-cols-2 gap-x-4 h-full pb-8 overflow-y-auto">
          <div className="w-full">
            {data?.previous_date?.map((i, idx) => (
              <p className="py-2 pl-5 text-xs 2xl:text-sm text-[#8C87A6]" key={idx}>
                {<NuDateFormat value={i} format="DD-MMM-YYYY" /> || "-"}
              </p>
            ))}
          </div>
          <div className="w-full">
            {data?.upcoming_date?.map((i, idx) => (
              <p className="py-2 pl-5 text-xs 2xl:text-sm text-[#8C87A6]" key={idx}>
                {<NuDateFormat value={i} format="DD-MMM-YYYY" /> || "-"}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardTableView;
